<template>
<div :class="{'my-message':'Author' in message && message.Author.id == $store.userDetails.id, 'small-window': size == 'small'}">

	<div v-if="message.imageUrl" class="avatar" :style="{backgroundImage: 'url('+message.imageUrl+')'}"></div>
	<div v-else class="avatar">
		<i class="fa fa-user-circle" :class="{'fa-3x': !size, 'fa-2x': size == 'small'}"></i>
	</div>

	<div class="message">		
		<div v-if="message.message" class="message-text">
			<i v-if="message.message != '[message contents deleted by author]'" class="fa fa-trash text-danger icon-button" title="Delete message" v-on:click="deleteMessage"></i>
			<pre v-html="mutatedMessage"></pre>
		</div>
		<image-panel
			v-if="'LibraryUpload' in message && message.LibraryUpload && message.LibraryUpload.type == 'Image'"
			:readonly="true"
			:image-url="fileUrl"
			:expand-url="expandUrl"
			v-on:open="openImage">
		</image-panel>
		<file-list-item v-else-if="'LibraryUpload' in message && message.LibraryUpload"
			:id="message.LibraryUpload.id"
			:src="fileUrl"
			:non-editable="true"
			:filename="message.LibraryUpload.original_filename">
		</file-list-item>
		<div class="meta" v-if="'Author' in message">
			<span>{{ message.Author.first_name }} {{message.Author.last_name}}</span> @
			<span>{{ createdAt }}</span>
		</div>
	</div>

	<div style="clear: both;"></div>
</div>
</template>

<script>
import ImagePanel from "@/components/ImagePanel"
import FileListItem from "@/components/FileListItem"

export default {
	name: 'MessageBubble',
	components: {
		ImagePanel,
		FileListItem
	},
	props: ["message","size"],
	computed: {
		mutatedMessage() {
			let regex = new RegExp("(http|https)://[a-zA-Z0-9-_./%?=+&]+","gi")

			let messageText = this.message.message

			//let findIndex

			let matchedLinks = messageText.match(regex)

			if (matchedLinks){
				matchedLinks.forEach(link => {
					messageText = messageText.replace(link,"<a href='"+link+"' target='_blank'>"+link+"</a>")
				})
			}

			return messageText
		},
		fileUrl() {
			if ("thumb_filename" in this.message.LibraryUpload && this.message.LibraryUpload.thumb_filename != "")
				return window.apiRoot+'resources/files/'+this.$store.sessionToken+'/'+this.message.LibraryUpload.thumb_filename
			else
				return window.apiRoot+"resources/files/"+this.$store.sessionToken+'/'+this.message.LibraryUpload.filename
		},
		expandUrl() {
			return window.apiRoot+"resources/images/"+this.$store.sessionToken+'/'+this.message.LibraryUpload.filename
		},
		createdAt() {
			let createdAt = this.moment.utc(this.message.created_at)

			let weekAgo = this.moment().utc().subtract(7,"days")

			let sixMonthAgo = this.moment().utc().subtract(180,"days")

			if (createdAt < sixMonthAgo)
				return this.formatDateTimeToLocal(this.message.created_at)
			else if (createdAt < weekAgo)
				return this.formatDateTimeToLocal(this.message.created_at,'month-day-time')
			else 
				return createdAt.local().format("ddd h:mm a")
		}
	},
	methods: {
		deleteMessage() {
			this.$emit("deleteMessageText")
		},
		openImage(url) {
			this.$store.mainImageViewerUrl = url
		}
	}
}
</script>

<style type="text/css">
	.message-text pre a {
		color: white;
		text-decoration: underline;
	}

	.my-message .message-text pre a {
		color: #007bff;
		text-decoration: underline;
	}
</style>

<style type="text/css" scoped>
	
	.avatar {
		width: 48px;
		height: 48px;
		background-position: center center;
		background-repeat: no-repeat;
		background-size: cover;
		border-radius: 50%;
		display: inline-block;
		vertical-align: top;
		margin-right: 20px;
	}

	.my-message .avatar {
		margin-right: 0;
		margin-left: 20px;
	}

	.small-window .avatar {
		margin-right: 10px;
		height: 32px;
		width: 32px;
	}

	.my-message.small-window .avatar {
		margin-left: 10px;
		margin-right: 0;
	}

	.message {
		margin-bottom: 20px;
		display: inline-block;

		width: calc(80% - 72px);
		vertical-align: top;
	}

	.small-window .message {
		width: calc(100% - 46px);
	}

	.small-window .message {
		margin-bottom: 10px;
	}

	.message-text pre {
		font-family: inherit;
		font-size: inherit;
		margin-bottom: 0;
		white-space: pre-wrap;
		word-wrap: break-word;
	}

	.message-text pre {
		color: white;
	}

	.my-message .message-text pre {
		color: black;
	}

	.message-text {
		background-color: #308cd0;
		border-top-left-radius: 10px;
		border-top-right-radius: 0;
		border-radius: 10px;
		border-top-left-radius: 0;
		padding: 3px;
		padding-left: 10px;
		padding-right: 10px;
		color: white;
		position: relative;
	}

	.message-text .icon-button {
		display: none;
		position: absolute;
		bottom: -3px;
		right: -3px;
	}

	.my-message .message-text:hover .icon-button {
		display: block;
	}

	.my-message .message-text {
		background-color: #e0e0e0;
		color: black;
		border-top-left-radius: 10px;
		border-top-right-radius: 0;
	}

	.my-message .message  {
		float: left;
		margin-left: 20%;
	}

	.my-message.small-window .message {
		margin-left: 0%;
	}

	.message .meta {
		font-size: 10pt;
		text-align: right;
		margin-top: 0px;
		margin-bottom: -5px;
	}


	@media (max-width: 500px) {
		.message, .my-message .message {
			width: calc(100% - 62px);
			margin-left: 0;
		}

		.my-message .avatar {
			margin-left: 10px;
		}

		.avatar {
			margin-right: 10px;
		}
	}
</style>
